import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AssignableDocumentType } from '@/features/document-templates/types/documentTemplates.types';
import { generateAgreementDocument } from '../services/agreementDocuments';
import { agreementKeys } from './agreementKeys';

/** A refused publish leaves a failed row behind, so the list is refreshed on failure as well as success. */
export function useGenerateDocument(agreementId: string | undefined) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (documentType: AssignableDocumentType) => generateAgreementDocument(agreementId ?? '', documentType),
        onSettled: () => {
            if (agreementId) {
                void queryClient.invalidateQueries({ queryKey: agreementKeys.documents(agreementId) });
            }
        },
    });
}
